/** @jsxImportSource @emotion/react */
// eslint-disable-next-line no-unused-vars
import React from "react";
import ElementWrapper from "../wrappers/ElementWrapper";
// import { parseStyle, decodeStyle } from "../parser/styleparser";
import classNames from "classnames";
import ContentEditable from "react-contenteditable";
import {
    decodeStyle,
    parseStyle,
    useAutoFitNew,
    getRecordId,
} from "../../../../junctionAbs";
import log from "cslog";

import QPopupForm from "../../../../../forms/QPopupForm";
import { css } from "@emotion/css";

function PopupForm({ id, db, gs, dydb, ctx }) {
    const data = db[id];

    const ps = parseStyle(data, gs, data.cstate);

    let input = ps.input;

    const record_id = getRecordId(dydb, input.editRecord);

    let field_overwrites = null;
    try {
        field_overwrites = input.fields_overwrite
            ? JSON.parse(input.fields_overwrite)
            : null;
    } catch (error) {}

    const btnData = input.buttonType;
    const icon = btnData?.type !== "text" && (
        <i
            className={btnData.params.icon.value}
            style={{
                zoom: 0.9,
                marginRight:
                    btnData?.params?.text && !btnData?.params?.icon_right
                        ? "1rem"
                        : "auto",
                marginLeft:
                    btnData?.params?.text && btnData?.params?.icon_right
                        ? "1rem"
                        : "auto",
            }}
        ></i>
    );

    return (
        <ElementWrapper id={id}>
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: input.buttonAlign,
                }}
            >
                {/* {ctx ? (
                    <pre>{JSON.stringify(ctx, null, 2)}</pre>
                ) : (
                    <p>ctx is null</p>
                )} */}
                <QPopupForm
                    id={input.form}
                    record_id={record_id}
                    org={ctx?.organization}
                    creation_id={ctx?.creation_id}
                    // title={record_id ? "Edit Item" : "Create Item"}
                    title="Fill Form"
                    field_overwrites={field_overwrites}
                    trigger={
                        <button
                            className={classNames(
                                input.hoverAnimation,
                                css({
                                    ...decodeStyle(ps.fixStyle, gs),
                                    ...decodeStyle(ps.styleGroup.button, gs),
                                    // ...(tablet(device) &&
                                    // decodeStyle(tabletStyle, gs)),
                                    // ...(mobile(device) &&
                                    // decodeStyle(mobileStyle, gs)),
                                    alignSelf: input.buttonAlign,
                                    textTransform: btnData?.params?.uppercase
                                        ? "uppercase"
                                        : "none",
                                    gap: "1.5rem",
                                    fontWeight: input.bold ? "bold" : "normal",
                                    fontSize: input.size || "12px",
                                    cursor: "pointer",
                                    margin: "10px",
                                    "&:hover": {
                                        ...decodeStyle(
                                            ps.style__hover || {},
                                            gs
                                        ),
                                    },
                                    "&:active": {
                                        ...decodeStyle(
                                            ps.style__selected || {},
                                            gs
                                        ),
                                    },
                                })
                            )}
                        >
                            {btnData?.params?.icon &&
                                !btnData.params.icon_right &&
                                icon}
                            {btnData?.params?.text && btnData.params.text}
                            {btnData?.params?.icon &&
                                btnData.params.icon_right &&
                                icon}
                        </button>
                    }
                    wrapper_style={{
                        background: "white",
                        fontSize: input.fontSize,
                        fontWeight: input.bold ? "bold" : "normal",
                        textTransform: input.uppercase ? "uppercase" : "none",
                    }}
                    configs={{
                        submitButtonText: input.submitButtonText,
                        submittingButtonText: input.submittingButtonText,
                        successMessage: input.successMessage,
                    }}
                />
            </div>
        </ElementWrapper>
    );
}

export default PopupForm;
